import React from 'react';
import { Grid } from '@mui/material';
import IndividualActions from '../components/IndividualActions';
import IndividualCardMassTreatmentPattern from '../components/IndividualCardMassTreatmentPattern';


function TreatmentIndividual({
    data,
}) {

    return (
        <Grid style={{
            width: '65%',
            display: 'flex',
            justifyContent: 'center', // Alinha os itens horizontalmente no centro
            // alignItems: 'center', // Alinha os itens verticalmente no centro
            borderRadius: '10px',
            boxShadow: '0px 12px 20px rgba(0, 0, 0, 0.1)',
            border: 'none',
        }}>
            <IndividualActions
                larguraDaTela={data.larguraDaTela}
                atualizarTamanhoDaTela={data.atualizarTamanhoDaTela}
                aprovedEvent={data.aprovedEvent}
                eventLocation={data.eventLocation}
                eventJustification={data.eventJustification}
                postAutoFix={data.postAutoFix}
            />
            <IndividualCardMassTreatmentPattern
                color={'#e01b38'}
                bigNumber={data.missingPoints}
                textOne={'Total de dias'}
                textTwo={'registros'}
                textThree={'ausentes'}
                atualizarTamanhoDaTela={data.atualizarTamanhoDaTela}
                larguraDaTela={data.larguraDaTela}
            />
            <IndividualCardMassTreatmentPattern
                color={'#ff9801'}
                bigNumber={data.eventLocation.length > 0 ? data.eventLocation.length : 0}
                textOne={'Registros'}
                textTwo={'pontos'}
                textThree={'fora do local'}
                atualizarTamanhoDaTela={data.atualizarTamanhoDaTela}
                larguraDaTela={data.larguraDaTela}
            />
            <IndividualCardMassTreatmentPattern
                color={'#ff9801'}
                bigNumber={data.eventJustification.length > 0 ? data.eventJustification.length : 0}
                textOne={'Registros'}
                textTwo={'pontos'}
                textThree={'justificados'}
                atualizarTamanhoDaTela={data.atualizarTamanhoDaTela}
                larguraDaTela={data.larguraDaTela}
            />
        </Grid >
    )
}


export default TreatmentIndividual;